import { render, staticRenderFns } from "./TablePaginatedCleaners.vue?vue&type=template&id=4bc5c88d&scoped=true"
import script from "./TablePaginatedCleaners.vue?vue&type=script&lang=js"
export * from "./TablePaginatedCleaners.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedCleaners.vue?vue&type=style&index=0&id=4bc5c88d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5c88d",
  null
  
)

export default component.exports